import AppContent from '../AppContent.vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import getQueryParameter from './getQueryParameter';

let router: ReturnType<typeof createRouter>;

export function createAppRouter(compiled: Content) {
  const hasAudio =
    Boolean(compiled?.course?.audio) ||
    Boolean(compiled?.course['audio-ai-jit']) ||
    JSON.stringify(compiled?.pages || '').includes('"audio":') ||
    JSON.stringify(compiled?.pages || '').includes('"speech":');
  const hasSfx = JSON.stringify(compiled || '').includes('"sfx":');
  const queryTags = getQueryParameter('tags');
  const audioDoc = Boolean(getQueryParameter('audioDoc'));
  const wordDoc =
    Boolean(queryTags?.includes('worddoc')) ||
    Boolean(getQueryParameter('word'));
  const initialPageId =
    (hasAudio || hasSfx) && !audioDoc && !wordDoc
      ? 'audio-popup'
      : compiled.pages[0].id;

  router = createRouter({
    history: createWebHashHistory(),

    routes: [
      { path: '/', redirect: `/${initialPageId}` },
      {
        path: '/:page',
        name: 'page',
        component: AppContent,
        children: [{ path: ':lightbox', name: 'lightbox', component: {} }]
      }
    ]
  });

  return router;
}

export default function getRouter() {
  return router;
}
